// Case-study diagrams pop in layer by layer, once, when they scroll into view.
//
// Pattern (any inline diagram SVG can opt in):
//   - wrap each node (shadow rect + box + labels) in <g class="pop">
//   - give arrows and loose labels class="pop-line"
//   - set style="--layer: N" on each; layer N starts N × .6s after the trigger.
//     Start at the diagram's origin (the hub, or the first step of a flow) and
//     let each arrow arrive with the later of the two nodes it connects.
//   - optional: wrap a problem node's face (not its shadow) in <g class="pop-angry">
//     and it hops off its shadow for a few seconds after popping in (CSS only).
// Without JS, or with reduced motion requested, diagrams simply render static.
(function () {
	const reduceMotion = document.documentElement.dataset.motion === 'reduce';
	if (reduceMotion || !('IntersectionObserver' in window)) {
		return;
	}

	const diagrams = Array.from(document.querySelectorAll('.cs-diagram .diagram-svg'))
		.filter(svg => svg.querySelector('.pop, .pop-line'));

	// Wait until most of the diagram is on screen, so the first layers don't
	// play out below the fold. Diagrams taller than the viewport trigger once
	// they fill most of it instead.
	const REQUIRED_VISIBLE = 0.75;
	const thresholds = Array.from({ length: 21 }, (_, i) => i / 20);

	// Measured vertically rather than by intersectionRatio (area): on narrow
	// screens a diagram scrolls sideways inside its box, so its visible area
	// can stay well under 75% even when it's fully on screen top to bottom.
	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			const height = entry.boundingClientRect.height || 1;
			const visible = entry.intersectionRect.height / height;
			const needed = Math.min(REQUIRED_VISIBLE, (window.innerHeight * REQUIRED_VISIBLE) / height);
			if (entry.isIntersecting && visible >= needed - 0.001) {
				entry.target.classList.add('popped');
				observer.unobserve(entry.target);
			}
		});
	}, { threshold: thresholds });

	diagrams.forEach(svg => {
		svg.classList.add('pop-ready');
		observer.observe(svg);
	});
})();
